import React, { useState } from 'react';
import { User, Mail, Phone, MapPin, Globe, FileText } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    workEmail: '',
    mobileNumber: '',
    country: '',
    city: '',
    state: '',
    enquiryDetails: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("/mail.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(formData).toString(),
    });

    const result = await response.json(); // ⬅️ Fix: parse as JSON

    if (result.status === "success") {
      alert("Enquiry submitted successfully!");
    } else {
      alert("Failed to send email: " + result.message);
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("An error occurred. Please try again later.");
  }

  setFormData({
    firstName: '',
    lastName: '',
    workEmail: '',
    mobileNumber: '',
    country: '',
    city: '',
    state: '',
    enquiryDetails: ''
  });
};


  return (
    <>
      <Navbar />

      {/* Contact Form Section */}
      <section className=" py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-screen-md  mx-auto bg-white p-10 rounded-3xl shadow-xl border border-gray-200">
          {/* Heading inside form */}
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-gray-800 mb-3">Let’s Get in Touch</h1>
            <p className="text-gray-600">We’d love to hear from you. Fill out the form below.</p>
          </div>

          <form onSubmit={handleSubmit} className="grid  grid-cols-1 md:grid-cols-2 gap-6">
            <FloatingField icon={<User />} label="First Name" name="firstName" value={formData.firstName} onChange={handleChange} />
            <FloatingField icon={<User />} label="Last Name" name="lastName" value={formData.lastName} onChange={handleChange} />
            <FloatingField icon={<Mail />} label="Work Email" name="workEmail" type="email" value={formData.workEmail} onChange={handleChange} />
            <FloatingField icon={<Phone />} label="Mobile Number" name="mobileNumber" type="tel" value={formData.mobileNumber} onChange={handleChange} />
            <FloatingField icon={<Globe />} label="Country" name="country" value={formData.country} onChange={handleChange} />
            <FloatingField icon={<MapPin />} label="State" name="state" value={formData.state} onChange={handleChange} />
            <FloatingField icon={<MapPin />} label="City" name="city" value={formData.city} onChange={handleChange} />

            {/* Enquiry Details */}
            <div className="col-span-1 md:col-span-2 relative">
              <label className="absolute left-4 top-3 text-gray-500">
                <FileText className="w-5 h-5" />
              </label>
              <textarea
                name="enquiryDetails"
                rows="4"
                required
                value={formData.enquiryDetails}
                onChange={handleChange}
                placeholder="Enquiry Details"
                className="w-full pl-10 pr-4 py-3 bg-white text-gray-700 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 placeholder-gray-400"
              />
            </div>

            {/* Submit */}
            <div className="col-span-1 md:col-span-2">
              <button
                type="submit"
                className="w-full py-4 bg-gradient-to-r from-pink-500 to-indigo-500 hover:from-pink-600 hover:to-indigo-600 text-white font-semibold rounded-xl shadow-lg transition duration-300"
              >
                Submit Enquiry
              </button>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </>
  );
};

// Reusable floating input component
const FloatingField = ({ label, name, type = 'text', icon, value, onChange }) => (
  <div className="relative">
    <label className="absolute left-4 top-3 text-gray-500">{icon}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={label}
      required
      className="w-full pl-10 pr-4 py-3 bg-white text-gray-700 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500 placeholder-gray-400"
    />
  </div>
);

export default Contact;
